import { createContext, useContext, useState } from 'react'
import { User } from 'types'

type AlertType = 'success' | 'info' | 'warning' | 'error'

interface StateContextProps {
  user: User | null
  setUser: (user: User | null) => void
  token: string | null
  setToken: (token: string | null) => void
}

// Create a new context called StateContext with default values for currentUser, token, and notification
const StateContext = createContext<StateContextProps>({
  user: null,
  setUser: () => {},
  token: null,
  setToken: () => {},
})

// Define a ContextProvider component that wraps its children with the context provider
export const ContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, _setUser] = useState<User | null>(null)
  const [token, _setToken] = useState<string | null>(localStorage.getItem('ACCESS_TOKEN'))
  
  const setToken = (token: string | null) => {
    _setToken(token)
    try {
      if (token) {
        localStorage.setItem('ACCESS_TOKEN', token)
      } else {
        localStorage.removeItem('ACCESS_TOKEN')
      }
    } catch (error) {
      console.error('Error updating local storage', error)
    }
  }

  const setUser = (user: User | null): void => {
    if (user && user.roles) {
      user.roles.sort((a, b) => a.localeCompare(b))
    }

    _setUser(user)
  }

  return (
    <StateContext.Provider
      value={{
        user,
        setUser,
        token,
        setToken,
      }}
    >
      {children}
    </StateContext.Provider>
  )
}

export const useStateContext = (): StateContextProps => useContext(StateContext)
